import { css } from "@emotion/react";

type Props = {
  text: string;
  width?: number;
  height?: number;
  backgroundColor?: string;
  children?: React.ReactNode;
};

const TextWithScroll: React.FC<Props> = (props) => {
  const {
    text,
    width = 300,
    height = 200,
    backgroundColor = "#FDF4F4",
    children,
  } = props;

  return (
    <div css={mainStyle(width, height, backgroundColor)}>
      <div css={TextWithScrollStyle(width, height, backgroundColor)}>
        <div css={textWrapperStyle}>{text}</div>
        {children}
      </div>
    </div>
  );
};

const primaryColor = "#D90012";

const mainStyle = (
  width: number,
  height: number,
  backgroundColor: string,
) => css`
  width: ${width}px;
  height: ${height}px;
  background-color: ${backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TextWithScrollStyle = (
  width: number,
  height: number,
  backgroundColor: string,
) => css`
  width: ${width - 20}px;
  height: ${height - 20}px;
  background-color: ${backgroundColor};
  white-space: pre-wrap;
  text-align: left;
  font-size: 8pt;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 7px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${backgroundColor};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${primaryColor};
  }
`;

const textWrapperStyle = css`
  padding: 12px 10px;
`;

export default TextWithScroll;
